import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { ApiResult, PromiseResult } from 'src/app/models/PromiseResult';
import { address, blockSpecialCharachters, city, DOCUMENT_SUPPORTED_TYPES, dose_input, GOOGLE_RECAPTCHA_SITE_KEY, IMAGE_PROFILE_ID_SUPPORTED_TYPES, name_input, number_input, phoneNumber, RESUME_SUPPORTED_TYPES, SALUTATIONS, textareaBox, URLS, USER_TYPES, zipCode } from 'src/app/constant/constant';
import { CountriesService } from 'src/app/services/countries.service';
import { DaterenderService } from 'src/app/services/daterender.service';
import { MessageService, SelectItem } from 'primeng';
import { boolean_dregistration, CountrySelectedValue, DoctorSaveData, dregistration, StateSelectedValue, StatesToPractice } from 'src/app/models/doctorregistration';
import { DoctorRegistrationCheckerService } from 'src/app/services/doctor-registration-checker.service';
import { DoctorReferralService } from 'src/app/services/doctor-referral.service';
import { SpecialityService } from 'src/app/services/speciality.service';
import { DoctorsService } from 'src/app/services/doctors.service';
import { UtilitiesService } from '../../../utilities/utilities.service';
import { HttpErrorResponse } from '@angular/common/http';
import { fileSize, fileType } from '../../../utilities/utilities';
import { Router } from '@angular/router';
import { UserTypes } from 'src/app/models/User';
import { TraceClassDecorator } from '@sentry/angular';
import { Form_Data } from 'src/app/models/util.models';
import { OtpInputComponent } from '../../shared/otp-input/otp-input.component';
import { UserService } from '../../../services/user.service';
import { ProviderStateService } from 'src/app/services/provider-state.service';
import { GoogleTranslateService } from 'src/app/services/google-translate.service';
import { CertificatesService } from 'src/app/services/certificates.service';


@Component({
    selector: 'app-register-doctor',
    templateUrl: './register-doctor.component.html',
    styleUrls: ['./register-doctor.component.css', './../login-home/login-home.component.css']
})
@TraceClassDecorator()
export class RegisterDoctorComponent implements OnInit {

    @ViewChild(OtpInputComponent) OTP_Input: OtpInputComponent;

    readonly name_input: RegExp = name_input;
    readonly address: RegExp = address;
    readonly city_input: RegExp = city;
    readonly phoneNumber: RegExp = phoneNumber;
    readonly zipCode: RegExp = zipCode;
    readonly textarea: RegExp = textareaBox;
    readonly dose_input: RegExp = dose_input;
    readonly number_input: RegExp = number_input;
    readonly blockSpecialCharachters: RegExp = blockSpecialCharachters;
    readonly sitekey: string = GOOGLE_RECAPTCHA_SITE_KEY;
    readonly user_types: UserTypes = USER_TYPES;
    readonly image_types: string[] = IMAGE_PROFILE_ID_SUPPORTED_TYPES;
    readonly resume_types: string[] = RESUME_SUPPORTED_TYPES;
    readonly document_types: string[] = DOCUMENT_SUPPORTED_TYPES;
    readonly acceptedAttachmentTypes = '.jpg,.jpeg,.png,.pdf,.doc,.docx,.dicom';
    slug: string = "";
    user_guid: string = "";
    is_uk_country: boolean = false;
    max_date = this.utilitiesService.getMaxDate();
    apiResult = new ApiResult(false);
    minDate: Date = new Date();
    doctorreg_boolean: boolean_dregistration = this.doctorRegistrationCheckerService.boolean_doctorRegistration_init();
    doctorreg: dregistration = this.doctorRegistrationCheckerService.doctorRegistration_init(true);
    fileType = fileType;
    // terms_and_conditions_url: string = this.utilitiesService.getBaseUrl("HOMPAGE_BASE_URL") + "terms-and-conditions";
    logo_url: string = '';
    provider_id: string = "";
    terms_and_conditions_url: string = this.utilitiesService.getBaseUrl("HOMPAGE_BASE_URL") + "terms-of-use";

    saveData: DoctorSaveData = this.doctorRegistrationCheckerService.DoctorSaveData_init("RegistrationV2");
    selectedLanguage: string;
    Document_data = [
        {
            id: 0,
            name: 'Enhanced DBS Certificate',
            data: []
        },
        {
            id: 1,
            name: 'GMC Certificate',
            data: []
        },
        {
            id: 2,
            name: 'Professional Indemnity Insurance',
            data: []
        }
    ];
    displayUploadDialog: boolean = false;

    uploadForm: {
        file: File | null;
        expiryDate: any;  // will be a Date object from p-calendar
    } = { file: null, expiryDate: '' };

    currentDocId: number | null = null;

    constructor(
        private readonly doctorsService: DoctorsService,
        private readonly referralService: DoctorReferralService,
        private readonly countriesService: CountriesService,
        private readonly specialtyservice: SpecialityService,
        private readonly daterenderService: DaterenderService,
        private readonly utilitiesService: UtilitiesService,
        private readonly doctorRegistrationCheckerService: DoctorRegistrationCheckerService,
        private readonly router: Router,
        private readonly changeDetector: ChangeDetectorRef,
        private readonly user: UserService,
        private providerStateService: ProviderStateService,
        private readonly translateService: GoogleTranslateService,
        private readonly certificateService: CertificatesService,
        private readonly messageService: MessageService,

    ) {
        this.max_date = this.utilitiesService.getMaxDate();
    }

    async ngOnInit() {
        // this.ResetResultModels();
        // this.formPosting = false;
        this.slug = this.providerStateService.getProviderSlug();
        if (URLS.IS_UK) {
            this.is_uk_country = true;
        }
        this.doctorreg_boolean = this.doctorRegistrationCheckerService.boolean_doctorRegistration_init();
        this.provider_id = this.providerStateService.getProviderId();
        this.doctorreg = this.doctorRegistrationCheckerService.doctorRegistration_init(true);
        this.max_date = this.utilitiesService.getMaxDate();
        this.doctorreg.others_data.years = this.utilitiesService.generate_years_list(1900, this.doctorreg.others_data.year, true);
        this.doctorreg.others_data.salutations = this.getSelectItemList(SALUTATIONS, "", "", false);

        this.doctorreg.table_data.MedicalSchool.columns.filter((element) => element.field == "year")[0]["data"] = this.doctorreg.others_data.years;
        this.doctorreg.table_data.Fellowship.columns.filter((element) => element.field == "year")[0]["data"] = this.doctorreg.others_data.years;
        this.doctorreg.table_data.Residency.columns.filter((element) => element.field == "year")[0]["data"] = this.doctorreg.others_data.years;
        this.doctorreg.others.fetchDataDialog = {
            show: false,
            data: {
                header: "Fetch the Saved Data",
                body_text: "Are you sure you want to restore previous filled data?",
                cancel_btn_label: "Close",
                cancel_btn_class: "btn btn-secondary",
                cancel_btn_display: true,
                confirm_btn_label: "Yes",
                confirm_btn_class: "btn btn-primary",
                confirm_btn_display: true,
            }
        };
        this.doctorreg.others.successDialog = {
            show: false,
            data: {
                header: "Registration Successful",
                body_text: "Registration has been successfully completed.",
                cancel_btn_label: "Close",
                cancel_btn_class: "btn btn-secondary",
                cancel_btn_display: false,
                confirm_btn_label: "Okay",
                confirm_btn_class: "btn btn-primary",
                confirm_btn_display: true,
            }
        }
        this.doctorreg.others.formData_apiResult = new ApiResult(false);
        this.doctorreg.others.recaptchaData.reset();
        // this.recaptchaReset();
        await this.getCountries();
        await this.getSpecialty();
        await this.getLanguages();
        await this.fetchSources();
        await this.isSaveData();
        this.logo_url = this.providerStateService.getLogoUrl();
        this.selectedLanguage = localStorage.getItem('selectedLanguageClient') || 'en';

        await this.translateService.googleTranslateElementInit();
        await this.translateService.setGoogleTranslateLanguage(this.selectedLanguage);
        // await this.confirmFetch();
    }

    isUK(): boolean {
        return this.doctorreg.others.selected_country_data?.id == 232;
    }

    private async fetchSources() {
        await this.user.fetchSources().toPromise().then(result => {
            this.doctorreg.others.user_source = result.map(src => {
                return {
                    label: src.user_source,
                    value: src.user_source_id
                }
            })
        }).catch(error => { });
    }

    filteredDocuments(): any[] {
        return this.Document_data.filter(d => d.data.length > 0);
    }

    onFileSelected(event: any, docId: number) {
        const selectedFile = event.files?.[0] ?? null;

        if (selectedFile) {
            this.currentDocId = docId;
            this.uploadForm = {
                file: selectedFile,
                expiryDate: ''
            };
            this.displayUploadDialog = true;
        }
    }

    cancelUpload() {
        this.displayUploadDialog = false;
        this.uploadForm = { file: null, expiryDate: '' };
        this.currentDocId = null;
    }

    confirmUpload() {
        if (!this.uploadForm.file || !this.uploadForm.expiryDate || this.currentDocId === null) {
            this.messageService.add({
                severity: 'warn',
                summary: 'Missing Information',
                detail: 'Please provide both file and expiry date.'
            });
            return;
        }

        const docIndex = this.Document_data.findIndex(d => d.id === this.currentDocId);
        if (docIndex > -1) {
            const formattedDate = this.uploadForm.expiryDate instanceof Date
                ? this.uploadForm.expiryDate.toISOString().split('T')[0]
                : this.uploadForm.expiryDate;

            this.Document_data[docIndex].data = [{
                file: this.uploadForm.file,
                expiryDate: formattedDate
            }];
        }

        this.displayUploadDialog = false;
        this.uploadForm = { file: null, expiryDate: '' };
        this.currentDocId = null;
    }

    async uploadCertificates() {
        for (const doc of this.Document_data) {
            if (doc.data.length > 0) {
                const cert = doc.data[0];
                const formData = new FormData();
                formData.append('name', doc.name);
                formData.append('expiryDate', cert.expiryDate);
                formData.append('file', cert.file);

                try {
                    const result = await this.certificateService
                        .UploadCertificate(formData, this.user_guid)
                        .toPromise();

                    console.log("Successfully uploaded", result);
                } catch (error: any) {
                    this.messageService.add({
                        severity: 'error',
                        detail: error.status == 500
                            ? 'Something went wrong!'
                            : error.error?.message?.toString() || 'Upload failed'
                    });
                }
            }
        }

        this.changeDetector.detectChanges();
    }

    isCertificateSectionValid(): boolean {
        if (!this.is_uk_country) return true;

        return this.Document_data.every(doc => {
            const cert = doc.data?.[0];
            return cert?.file && cert?.expiryDate;
        });
    }

    fetchDataDialogAction(event) {
        if (Boolean(event)) {
            this.confirmFetch();
        }
        else {
            this.doctorreg.others.fetchDataDialog.show = false;
        }
    }

    successDataDialogAction(event) {
        if (Boolean(event)) {
            this.gotoHome();
        }
    }

    gotoHome() {
        this.RouterNavigation("/");
    }

    isPosting(): boolean {
        return this.doctorreg.others.formData_apiResult.Posting ||
            this.doctorreg.others.otp_data.otp_api_result.Posting ||
            this.doctorreg.others.form_error_message_result.Posting
    }


    RouterNavigation(path: string) {
        this.router.navigate(['/' + this.slug + '/' + path]);
    }

    async isSaveData() {
        if (!Boolean(JSON.parse(localStorage.getItem(this.saveData.local_storage_object_name))))
            this.saveData.masterChecker = false;
        else
            this.saveData.masterChecker = Boolean(this.isNotNullObject(JSON.parse(localStorage.getItem(this.saveData.local_storage_object_name))))
        if (this.saveData.masterChecker) {
            this.doctorreg.others.fetchDataDialog.show = true;
        }
    }

    async confirmFetch() {
        this.doctorreg.others.fetchDataDialog.show = false;
        if (Boolean(JSON.parse(localStorage.getItem(this.saveData.local_storage_object_name)))) {
            await this.NullChecker();
            if (Boolean(this.doctorreg.others.selected_country_data?.id)) {
                await this.onChangeCountry();
                this.doctorreg.others.selected_state = this.doctorreg.others_data.states.filter((ele) => ele.label == this.doctorreg.api_data.state_name)[0].value;
                this.doctorreg.others.StatesToPractice = this.doctorreg.api_data.states_to_practice;
                if (this.doctorreg.api_data.states_to_practice?.length > 0 &&
                    this.doctorreg.api_data.states_to_practice?.length == 1 &&
                    this.doctorreg.api_data.states_to_practice[0].state_id == 0 &&
                    this.doctorreg.api_data.states_to_practice[0].state_name == "ALL") {
                    this.doctorreg.others.national_license_number = this.doctorreg.api_data.states_to_practice[0].license_no
                }
                this.doctorreg.api_data.avatar = null;
                this.doctorreg.api_data.resume = null;

            }
        }
    }

    async isNotNullObject(obj: any) {

        return this.doctorRegistrationCheckerService.isNotNullObject(obj)
    }

    async NullChecker() {
        // this.saveData.masterChecker = Boolean(this.isNotNullObject(JSON.parse(localStorage.getItem(this.saveData.local_storage_object_name))))
        if (this.saveData.masterChecker) {
            this.doctorreg = this.doctorRegistrationCheckerService.fetchDataLocalStorage(this.saveData.local_storage_object_name, this.doctorreg);
        }
    }

    saveLocal() {
        this.doctorRegistrationCheckerService.saveDataLocalStorage(this.saveData.local_storage_object_name, this.doctorreg);
    }


    async onChangeCountry() {
        console.log("onChangeCountry");
        // console.log(this.isUK())
        console.log(this.doctorreg.others.selected_country_data?.id)
        this.doctorreg.others.StatesToPractice = [];
        this.refreshTableData("StatesToPractice");
        this.doctorreg.others.national_license_number = "";
        this.doctorreg.others.selected_country_data = JSON.parse(this.doctorreg.others.selected_country) as CountrySelectedValue || this.doctorRegistrationCheckerService.getCountrySelectedValue_init();
        this.doctorreg.others.phone_code = this.doctorreg.others.selected_country_data.phone_code || "";
        this.doctorreg.others.is_national_license = Boolean(this.doctorreg.others.selected_country_data.is_national_license);
        let states_data_result
        await this.countriesService.getStates(this.doctorreg.others.selected_country_data?.id)
            .toPromise()
            .then(states => {
                states_data_result = states;
            }).catch(error => { });;
        let final_states_data = states_data_result.map(
            function (element) {
                element.final_value = JSON.stringify({
                    id: element.id,
                    state_name: element.state_name,
                })
                return element;
            }
        );
        this.doctorreg.others_data.states = this.getSelectItemList(final_states_data, "state_name", "final_value", false);

        this.doctorreg.table_data.StatesToPractice.columns.filter((element) => element.field == "state_data")[0]["data"] = this.doctorreg.others_data.states;
    }

    async getCountries(): Promise<void> {
        let countries_data_result
        await this.countriesService.getCountries(this.provider_id).toPromise()
            .then(countries => {
                countries_data_result = countries;
            }).catch(error => { });;
        let final_countries_data = countries_data_result.map(
            function (element) {
                element.final_value = JSON.stringify({
                    id: Number(element.id),
                    is_national_license: element.is_national_license,
                    phone_code: "+" + String(element.phone_code),
                    country_name: element.country_name
                } as CountrySelectedValue);
                return element;
            }
        );
        this.doctorreg.others_data.countries = this.getSelectItemList(final_countries_data, "country_name", "final_value", false);

    }

    async getSpecialty() {
        let specialty_data_result
        await this.specialtyservice.GetAllSpecialities(undefined, this.provider_id).toPromise()
            .then(result => {
                specialty_data_result = result.data
            }).catch(error => { });;
        let final_specialty_data = specialty_data_result.map(
            function (element) {
                element.final_value = Number(element.id);
                return element;
            }
        );
        this.doctorreg.others_data.primary_specialties = this.getSelectItemList(final_specialty_data, "specialty_name", "final_value", false);
        this.doctorreg.others_data.secondary_specialties = this.getSelectItemList(final_specialty_data, "specialty_name", "specialty_name", false);
    }

    async getLanguages() {
        let languages_data_result: PromiseResult
        await this.doctorsService.GetLanguageSpoken().toPromise().then(result => {
            languages_data_result = result;
        }).catch(error => { });
        if (languages_data_result.success) {
            var languages_data = languages_data_result.data.map(
                function (element) {
                    element.mixed_label_string = element.english_name + "(" + element.language_name + ")"
                    return element;
                }
            );
            this.doctorreg.others_data.languages = this.getSelectItemList(languages_data, "mixed_label_string", "id", false);
        }
    }

    resolved(captchaResponse: any) {
        this.doctorreg.api_data.recaptcha = captchaResponse;
    }

    async openLink(base_url_name: string, link: string, target: string): Promise<void> {
        this.utilitiesService.openWebsiteLinks(base_url_name, link, target);
    }

    getSelectItemList(data: any, label: string, value: string, want_null: boolean): SelectItem[] {
        return this.utilitiesService.getSelectItemList(data, label, value, want_null);
    }

    range(start: number, end: number): number[] {
        return this.utilitiesService.range(start, end);
    }

    getIsNationalLicense(): boolean {
        return this.doctorreg.others.is_national_license;
    }

    getIsSelectedCountryEmpty(): boolean {
        return this.doctorreg.others.selected_country_data.id == null && this.doctorreg.others.selected_country_data.is_national_license == null || this.doctorreg.others.selected_country_data.phone_code == null;
    }

    processStatesToPractice(element: StatesToPractice) {
        let a: StateSelectedValue = JSON.parse(element["state_data"]) as StateSelectedValue;
        element["state_id"] = a.id;
        element["state_name"] = a.state_name;
        return element;
    }

    update(table_type: string, event) {
        if (table_type === "MedicalSchool") {
            this.doctorreg.others.MedicalSchool = event;
        }
        else if (table_type === "StatesToPractice") {
            let StatesToPractice: StatesToPractice[] = event as StatesToPractice[];
            this.doctorreg.others.StatesToPractice = StatesToPractice.map((ele) => this.processStatesToPractice(ele));
            // this.doctorreg.others.MedicalSchool=event;
        }

    }

    async refreshTableData(table_name: string) {
        this.doctorreg.table_data[table_name].refresh = false;
        setTimeout(() => {
            this.doctorreg.table_data[table_name].refresh = true;
        }, 1000)

    }

    async submitFormData() {

        // this.recaptchaReset();
        // this.ResetResultModels();
        // this.formPosting = true;   
        if (Boolean(this.doctorreg.api_data.date_of_birth_date))
            this.doctorreg.api_data.date_of_birth = this.daterenderService.render_data(this.doctorreg.api_data.date_of_birth_date);
        this.doctorreg.others.selected_state_data = JSON.parse(this.doctorreg.others.selected_state) as StateSelectedValue || this.doctorRegistrationCheckerService.getStateSelectedValue_init();
        this.doctorreg.api_data.state_name = this.doctorreg.others.selected_state_data.state_name || null;

        this.doctorreg.api_data.timezone = 0;
        this.doctorreg.api_data.featured_doctor_id = false;
        this.doctorreg.api_data.role_id = 1;

        this.doctorreg.api_data.country_id = this.doctorreg.others.selected_country_data?.id || null;

        this.doctorreg.api_data.primary_contact_number = this.doctorreg.others.phone_code + this.doctorreg.others.primary_number;

        this.doctorreg.api_data.secondary_contact_number = this.doctorreg.others.phone_code + this.doctorreg.others.secondary_number;

        this.doctorreg.others.MedicalSchool = this.doctorreg.others.MedicalSchool.filter((element) => element.name.length > 0 && element.year.length > 0);
        this.doctorreg.others.StatesToPractice = this.doctorreg.others.StatesToPractice.filter((element) => element.license_no.length > 0 && element.state_data.length > 0);

        await this.refreshTableData("MedicalSchool");
        this.update('MedicalSchool', this.doctorreg.others.MedicalSchool);
        await this.refreshTableData("StatesToPractice");
        this.update('StatesToPractice', this.doctorreg.others.StatesToPractice);

        this.doctorreg.api_data.education = {
            medical_school: this.doctorreg.others.MedicalSchool,
            residency: this.doctorreg.others.Residency,
            fellowship: this.doctorreg.others.Fellowship
        };

        if (!this.doctorreg.others.is_national_license) {
            this.doctorreg.api_data.states_to_practice = this.doctorreg.others.StatesToPractice;
        }
        else if (this.doctorreg.others.is_national_license) {
            this.doctorreg.api_data.states_to_practice = [];
            if (this.doctorreg.others.national_license_number.length > 0) {
                this.doctorreg.api_data.states_to_practice.push({
                    si_no: "1",
                    state_name: "ALL",
                    state_id: 0,
                    license_no: this.doctorreg.others.national_license_number,
                    state_data: JSON.stringify({
                        state_name: "ALL",
                        state_id: 0
                    }),
                })
            }
        }

        this.doctorreg_boolean = await
            this.doctorRegistrationCheckerService
                .DoctorRegistrationFormSubmitChecker(
                    this.doctorreg.api_data,
                    this.doctorreg.others.is_super_admin,
                    this.doctorreg.api_data.avatar,
                    this.doctorreg.others.signatureOptionSelected,
                    this.doctorreg.others.signatureFile,
                    this.doctorreg.others.agree
                );
        this.doctorreg.others.form_error_message_result.PromiseResult =
            await this.doctorRegistrationCheckerService
                .getDoctorRegFormErrors(
                    this.doctorreg_boolean,
                    this.doctorreg.others.selected_country_data.is_national_license
                );
        if (!this.doctorreg.others.form_error_message_result.PromiseResult.success) {
            // this.formPosting = false;
            this.doctorreg.others.formData_apiResult.Posting = false;
        }
        if (this.doctorreg.others.form_error_message_result.PromiseResult.success) {
            await this.uploadData();
        }
    }

    async register_validate_or_resend_otp() {
        this.doctorreg.others.otp_data.otp_api_result = new ApiResult(true);
        await this.referralService
            .register_doctor_validate_or_resend_otp(this.doctorreg.others.otp_data.OTP_validate_api)
            .toPromise()
            .then(async (result) => {
                this.doctorreg.others.otp_data.otp_api_result.PromiseResult = result;
                if (result.success) {
                    if (this.doctorreg.others.otp_data.OTP_validate_api.retry) {
                        this.set_data(result);
                        this.changeDetector.detectChanges();
                        this.OTP_Input.init_countdown();
                    }
                    else {
                        this.utilitiesService.RouterNavigation(
                            '/user/thank-you/' + this.user_types['DOCTOR']
                        );
                    }
                }
                this.doctorreg.others.otp_data.otp_api_result.Posting = false;
            })
            .catch((error: HttpErrorResponse) => {
                this.doctorreg.others.otp_data.otp_api_result.ServerError = error.error;
                this.doctorreg.others.otp_data.otp_api_result.PromiseResult.success = false;
                this.doctorreg.others.otp_data.otp_api_result.Posting = false;
            })
    }

    async otpVerifySubmit() {
        this.doctorreg.others.otp_data.OTP_validate_api.retry = false;
        await this.register_validate_or_resend_otp();
    }

    async otp_resend() {
        this.doctorreg.others.otp_data.OTP_validate_api.retry = true;
        await this.register_validate_or_resend_otp();
    }

    set_data(result: PromiseResult) {
        this.doctorreg.others.otp_data.OTP_validate_api.user_guid = result.data.user_guid;
        this.doctorreg.others.otp_data.OTP_validate_api.service_id = result.data.service_id;
        this.doctorreg.others.otp_data.OTP_validate_api.retry_after = new Date(result.data.retry_after);
    }

    certificates: Array<{
        name: string;
        expiryDate: string;
        file: File | null;
        fileName: string;
        isEditing: boolean;
    }> = [];
    
    certificates_data: Array<{ name: string; expiryDate: string }> = [];
    
    // Add a new certificate row
    addCertificate() {
        this.certificates.push({
            name: '',
            expiryDate: '',
            file: null,
            fileName: '',
            isEditing: true, // New rows are in edit mode
        });
    }
    
    // Handle file upload
    onFileUpload(event: Event, index: number) {
        const fileInput = event.target as HTMLInputElement;
        if (fileInput.files && fileInput.files.length > 0) {
            this.certificates[index].file = fileInput.files[0];
            this.certificates[index].fileName = fileInput.files[0].name;
        }
    }

    onFileRemoved(docId: number): void {
    const docIndex = this.Document_data.findIndex(d => d.id === docId);
    if (docIndex > -1) {
        this.Document_data[docIndex].data = []; // Clear the uploaded data
    }

    // Reset any related form data if needed
    if (this.currentDocId === docId) {
        this.uploadForm = { file: null, expiryDate: '' };
        this.currentDocId = null;
    }

    // Detect changes to update UI
    this.changeDetector.detectChanges();
}

    
    // Save the certificate
    save(cert: any) {
        if (!cert.name || !cert.expiryDate || !cert.file) {
            alert('Please fill all fields and upload a file before saving.');
            return;
        }
    
        // Push metadata to certificates_data
        this.certificates_data.push({
            name: cert.name,
            expiryDate: cert.expiryDate,
        });
    
        // Retain the file in certificates array
        cert.isEditing = false; // Exit edit mode
    }
    
    // Edit certificate
    edit(cert: any) {
        cert.isEditing = true;
    }
    
    // Cancel editing
    cancel(cert: any) {
        if (!cert.fileName) {
            // Remove unsaved rows or reset unsaved changes
            const index = this.certificates.indexOf(cert);
            if (index > -1) {
                this.certificates.splice(index, 1);
            }
        } else {
            cert.isEditing = false;
        }
    }
    
    // Remove certificate row
    remove(cert: any) {
        const index = this.certificates.indexOf(cert);
        if (index > -1) {
            this.certificates.splice(index, 1);
        }
    }
    
    // Determine if Save button should be enabled
    canSave(cert: any): boolean {
        return cert.name && cert.expiryDate && cert.file;
    }
    

    async uploadData() {
        this.doctorreg.others_data.form_data = new Form_Data();
        this.doctorreg.others_data.form_data.form_data = this.doctorreg.others_data.form_data.create_form_data(this.doctorreg.api_data, new FormData(), "");
    
        // Append certificates_data
        if (this.certificates.length > 0) {
            this.certificates.forEach((cert, index) => {
                // Append individual fields
                this.doctorreg.others_data.form_data.form_data.append(`certificates_data[${index}][name]`, cert.name);
                this.doctorreg.others_data.form_data.form_data.append(`certificates_data[${index}][expiryDate]`, cert.expiryDate);
    
                // Append file
                if (cert.file) {
                    this.doctorreg.others_data.form_data.form_data.append(`certificates[${index}]`, cert.file, cert.fileName);
                }
            });
        }
    
        // Handle upload via API
        await this.referralService
            .CreateDoctor(this.doctorreg.others_data.form_data.form_data)
            .toPromise()
            .then(result => {
                this.doctorreg.others.formData_apiResult.PromiseResult = result;
                if (result.success) {
                    this.set_data(result);
                    this.doctorreg.others.tabViewData.nextTab(1);
                    this.user_guid = result.data.user_guid;
                    this.uploadCertificates();
                    // this.utilitiesService.RouterNavigation('/user/thank-you/' + this.user_types['DOCTOR']);
                } else {
                    this.doctorreg.others.formData_apiResult.PromiseResult.success = false;
                }
                this.doctorreg.others.formData_apiResult.Posting = false;
                this.doctorreg.others.successDialog.show = result.success;
            })
            .catch((error: HttpErrorResponse) => {
                this.doctorreg.others.formData_apiResult.ServerError = error.error;
                this.doctorreg.others.formData_apiResult.PromiseResult.success = false;
                this.doctorreg.others.formData_apiResult.Posting = false;
            });
    }
    

    submitDoctorRegistration() {
        let waitSec = Number((Math.floor(Math.random() * 1000) + 1) % 3);
        // this.formPosting = true;
        this.doctorreg.others.form_error_message_result = new ApiResult(false);
        this.doctorreg.others.formData_apiResult = new ApiResult(true);
        this.doctorreg.others.recaptchaData.reset();
        setTimeout(async () => {
            await this.submitFormData();
        }, 5000 + waitSec);
    }


    fileSave(type: fileType, file: File) {
        if (file.size > fileSize[type]) file = null;
        switch (type) {
            case fileType.resume: this.doctorreg.api_data.resume = file;
                break;
            case fileType.photo: this.doctorreg.api_data.avatar = file;
                break;
            default: break;
        }
    }

}
